(function () {
    "use strict";

    angular
        .module("showcaseApp")
        .component("sellerCampaignItem", {
            templateUrl:
                "app/admin/seller-campaigns/seller-campaign-item/seller-campaign-item.html",
            controller: SellerCampaignItemController,
            bindings: {
                item: "=",
                selectedTab: "=",
                onFinishActivity: "&",
                onCampaignStarted: "&"
            },
        })
        .directive("directiveWhenScrolled", function () {
            return function (scope, elm, attr) {
                var raw = elm[0];

                elm.bind("scroll", function () {
                    if (raw.scrollTop + raw.offsetHeight >= (raw.scrollHeight - 20)) {
                        scope.$apply(attr.directiveWhenScrolled);
                    }
                });
            };
        });

    /** @ngInject */
    function SellerCampaignItemController(SellerActivityService, sellerActivityConstants, $uibModal, $uibModalStack, toastr, $translate, moment, $scope, $window, $q, MODAL_CONTENT_TYPES) {
        var $ctrl = this;

        $ctrl.isExpanded = false;
        $ctrl.deadlineMap = {
            NORMAL: "NORMAL",
            MEDIAN: "MEDIAN",
            URGENT: "URGENT",
            INDETERMINATE: 'INDETERMINATE'
        };

        $ctrl.currentPage = 1;
        $ctrl.numPerPage = 10;
        $ctrl.maxSize = 5;

        $ctrl.sellerActivities = [];

        $ctrl.paginationOptions = {
            page: $ctrl.currentPage - 1,
            size: $ctrl.numPerPage,
            sort: null,
        };

        var activityStatus = sellerActivityConstants.ACTIVITY_STATUS;

        const DATE_FORMAT = $translate.instant('momentDateFormat');

        function calculatePercentage(done, quota) {
            if (quota > 0) {
                return Math.round((done / quota) * 100);
            }
            return done > 0 ? 100 : 0;
        }

        function recomputeProgress() {
            $ctrl.percentage = calculatePercentage(
                $ctrl.item.totalActivitiesFinished,
                $ctrl.item.autoAssignedTotal
            );
            $ctrl.barWidth = Math.min($ctrl.percentage, 100);
            $ctrl.content = $ctrl.percentage + "%";
        }

        $ctrl.statusDisplayMap = {
            CANCELLED: {
                class: 'cancelled',
                label: 'seller-activities.list.badges.cancelled',
                tooltip: 'seller-activities.list.tooltip.cancelled'
            },
            DONE: {
                class: 'done',
                label: 'seller-activities.list.badges.done',
                tooltip: 'seller-activities.list.tooltip.done'
            },
            DOING: {
                class: 'in-progress',
                label: 'seller-activities.list.badges.in-progress',
                tooltip: 'seller-activities.list.tooltip.in-progress'
            },
            PENDING: {
                class: 'pending',
                label: 'seller-activities.list.badges.pending',
                tooltip: 'seller-activities.list.tooltip.pending'
            }
        };

        $ctrl.$onInit = function () {
            if($ctrl.item.campaign.expirationDate) {
                $ctrl.formatedExpirationDate =  moment($ctrl.item.campaign.expirationDate).format(DATE_FORMAT);
            }
            $ctrl.mobileTooltipMap = {};
            updateIsMobile();

            recomputeProgress();
        };

        $ctrl.$toggleExpansion = function () {
            $ctrl.isExpanded = !$ctrl.isExpanded;
            if ($ctrl.isExpanded && $ctrl.sellerActivities.length === 0) {
                getSellerActivities($ctrl.paginationOptions);
            }
        };

        $ctrl.$getDateDeadline = function (expirationDate) {
            if ($ctrl.item.campaign.status === 'DONE') {
                return $ctrl.item.campaign.status;
            }

            if (!expirationDate) {
                return $ctrl.deadlineMap.INDETERMINATE;
            }

            var today = moment().startOf('day');

            var expiration = moment(expirationDate).startOf('day');

            var diffInDays = expiration.diff(today, 'days');

            if (diffInDays >= 0 && diffInDays < 2) {
                return $ctrl.deadlineMap.URGENT;
            } else if (diffInDays >= 2 && diffInDays <= 4) {
                return $ctrl.deadlineMap.MEDIAN;
            } else {
                return $ctrl.deadlineMap.NORMAL;
            }
        };

        function getSellerActivities(pagination) {
            $ctrl.loading = true;

            var params = {};
            params.campaignId = $ctrl.item.id;

            SellerActivityService.findByCampaignId(pagination, params).then(
                function (response) {
                    $ctrl.sellerActivities = $ctrl.sellerActivities.concat(response.data.activities);
                    updateAllStatusTags($ctrl.sellerActivities.concat(response.data.activities));
                    $ctrl.totalSellerActivities = response.data.total;
                    $ctrl.loading = false;
                }
            );
        }

        function reloadActivities() {
            $ctrl.sellerActivities = [];
            $ctrl.currentPage = 1;
            $ctrl.paginationOptions.page = 0;
            getSellerActivities($ctrl.paginationOptions);
        }

        $ctrl.$loadMore = function() {
            if ($ctrl.loading) return;
            if ($ctrl.totalSellerActivities > $ctrl.sellerActivities.length) {
                $ctrl.loading = true;
                $ctrl.currentPage = $ctrl.currentPage + 1;
                $ctrl.paginationOptions.page = $ctrl.currentPage - 1;
                getSellerActivities($ctrl.paginationOptions);
            }

        };

        $ctrl.$startActivity = function (activity) {
            var index = $ctrl.sellerActivities.findIndex(function (item) {
                return item.id === activity.id;
            });

            if (index === -1) return;

            return $uibModal.open({
                templateUrl: "app/admin/seller-campaigns/send-message-modal/send-message-modal.html",
                windowClass: 'modal-side-menu',
                size: 'md',
                controller: "SendMessageModalController",
                controllerAs: "vm",
                backdrop: 'static',
                resolve: {
                    campaign: function () {
                        return $ctrl.item.campaign;
                    },
                    activity: function () {
                        return activity;
                    },
                    onSendMessage: function () {
                        return function () {
                            if (activity.status === activityStatus.PENDING) {
                                return updateActivityStatus(activity, activityStatus.DOING);
                            }
                            return $q.resolve(true);
                        };
                    }
                },
            }).result.then(function (result) {
                if (angular.isDefined(result)) {
                    if (result) {
                        updateActivityStatus(activity, activityStatus.DONE);
                    }
                }
            });
        };

        $ctrl.$openSideMenu = function (customer, index) {
            return $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                controllerAs: 'vm',
                windowClass: 'side-modal',
                backdrop: 'static',
                resolve: {
                    content: function () {
                        return {
                            customer: customer,
                            type: MODAL_CONTENT_TYPES.CUSTOMER
                        }
                    }
                }
            }).result.then(function (result) {
                if (!result) return;
                var newCustomer = {
                    address: result.address,
                    id: result.id,
                    state: result.state,
                    phone: result.phone,
                    email: result.email,
                    fullName: result.fullName,
                    createdThrough: result.createdThrough,
                    birthdate: result.birthDate,
                    city: result.city,
                    gender: result.gender === 'messages.gender.male' ? 'MALE' : result.gender === 'messages.gender.female' ? 'FEMALE' : null,
                    district: result.district,
                    whatsapp: result.whatsapp,
                    addressNumber: result.addressNumber,
                    zipcode: result.zipCode
                };
                $ctrl.sellerActivities[index].customer = newCustomer;
            });
        };

        function updateActivityStatus(activity , newStatus) {
            var index = $ctrl.sellerActivities.findIndex(function (item) {
                return item.id === activity.id;
            });
            if (index === -1) return $q.resolve(false);
            var previousStatus = activity.status;
            return SellerActivityService.updateStatus(activity.id, { status: newStatus }).then(function (result) {
                activity.status = newStatus;
                $ctrl.sellerActivities.splice(index, 1, activity);

                if (previousStatus === activityStatus.PENDING && newStatus !== activityStatus.PENDING
                    && $ctrl.item.pendingActivities > 0) {
                    $ctrl.item.pendingActivities -= 1;

                    if ($ctrl.item.campaign.status === activityStatus.PENDING) {
                        $ctrl.item.campaign.status = activityStatus.DOING;
                        if (angular.isFunction($ctrl.onCampaignStarted)) {
                            $ctrl.onCampaignStarted();
                        }
                    }
                }
                if (newStatus === activityStatus.DONE && previousStatus !== activityStatus.DONE) {
                    $ctrl.item.totalActivitiesFinished = ($ctrl.item.totalActivitiesFinished || 0) + 1;
                }

                recomputeProgress();
                updateAllStatusTags($ctrl.sellerActivities);
                return true;
            }).catch(function (error) {
                if (error.data.data.errorKey === "ERROR_CANNOT_UPDATE_STATUS_TO_ACTIVITY") {
                    toastr.error($translate.instant('seller-activities.errors.update-activity-status'));
                    $uibModalStack.dismissAll();
                    reloadActivities();
                    $ctrl.onFinishActivity();
                }
                return false;
            });
        }

        function updateAllStatusTags(sellerActivities) {
            sellerActivities.forEach(function (item) {
                var config = $ctrl.statusDisplayMap[item.status];
                if (config) {
                    item.statusTag = {
                        class: config.class,
                        label: $translate.instant(config.label),
                        tooltip: $translate.instant(config.tooltip)
                    };
                } else {
                    item.statusTag = null;
                }
            });
        }

        function updateIsMobile() {
            $ctrl.isMobile = window.innerWidth <= 768;
        }

        $ctrl.isTooltipOpen = function (id) {
            return !!$ctrl.mobileTooltipMap && $ctrl.mobileTooltipMap[id];
        };

        $ctrl.toggleMobileTooltip = function (id, $event) {
            $event.stopPropagation();

            Object.keys($ctrl.mobileTooltipMap).forEach(function (key) {
                $ctrl.mobileTooltipMap[key] = false;
            });

            $ctrl.mobileTooltipMap[id] = true;
        };

        angular.element($window).on('resize', function () {
            $scope.$apply(updateIsMobile);
        });
    }
})();
